export default "__VITE_ASSET__CK0FMi9l__"